const config = {
  //appStyle: "tt", // Standardwert
  bookmarkUrl: "https://interface.touchtomorrow.de/user/", // wenn es mehr als ein bookmarkurl gibt, muss man diesen wert auslagern
   appStyle: "me", // Standardwert
  // images: ["test", "test1","QR"],
  // svg: ["logo", "biglogo", "close","prev","next","check","icons8-menue"]
};

export default config;